import { Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Ellipsis } from './ui/Ellipsis';
import { trim } from 'utils/string';
// @ts-expect-error [EN-10263] - TS7016 - Could not find a declaration file for module 'react-resize-aware'. '/Users/danyim/Dev/services-frontend-experiment/frontend/node_modules/react-resize-aware/dist/index.umd.js' implicitly has an 'any' type.
import useResizeAware from 'react-resize-aware';

type Props = {
  css?: string;
  name: string;
  className?: string | undefined;
  conditionalTooltip?: boolean;
  customEllipsisCss?: unknown | null;
  ['data-testid']?: string;
  variant?: 'default' | 'noWrap';
};

const NoMaxWidthTooltip = withStyles((theme) => ({
  tooltip: {
    maxWidth: 'none',
  },
}))(Tooltip);

const TextWithTooltip = ({
  name,
  className,
  conditionalTooltip = false,
  customEllipsisCss = null,
  'data-testid': dataTestid,
  variant = 'default',
}: Props): React.ReactElement => {
  // @ts-expect-error [EN-10263] - TS7006 - Parameter 'target' implicitly has an 'any' type.
  const [resizeListener, sizes] = useResizeAware((target) => ({
    clientWidth: target?.parentElement?.clientWidth ?? 0,
    scrollWidth: target?.parentElement?.scrollWidth ?? 0,
  }));

  const isOverflowing = sizes != null ? sizes.scrollWidth > sizes.clientWidth : false;
  return (
    <Ellipsis
      data-privacy
      css={{
        minWidth: 0,
        display: 'inline-block',
        padding: 0,
        position: 'relative',
        // @ts-expect-error [EN-7967] - TS2698 - Spread types may only be created from object types.
        ...customEllipsisCss,
      }}
      className={className}
      data-testid={dataTestid}
      data-value={trim(name)}
    >
      {resizeListener}
      {variant === 'default' ? (
        <Tooltip title={name} disableHoverListener={conditionalTooltip === true && !isOverflowing}>
          <span>{name}</span>
        </Tooltip>
      ) : variant === 'noWrap' ? (
        <NoMaxWidthTooltip
          title={name}
          disableHoverListener={conditionalTooltip === true && !isOverflowing}
        >
          <span>{name}</span>
        </NoMaxWidthTooltip>
      ) : null}
    </Ellipsis>
  );
};

export default TextWithTooltip;
